import { Component, Input, HostListener, ViewChild, ElementRef, AfterViewInit } from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { DealConfigurationQuery } from 'generated/graphql'
import { ActionBannerService } from 'modules/deals/configurator/services/action-banner.service'
import { Observable, ReplaySubject } from 'rxjs'

@UntilDestroy()
@Component({
    selector: 'mg-checkout-options-layout',
    templateUrl: './checkout-options-layout.component.html',
    styleUrls: ['./checkout-options-layout.component.scss'],
})
export class CheckoutOptionsLayoutComponent implements AfterViewInit {
    remainingOptionsElementOffset: number
    isSidebarSticky: boolean
    isMobileInfoPanelOpen: boolean = false
    isPrecededByActionBanner: boolean = false

    constructor(private actionBannerService: ActionBannerService) {}

    @Input() deal$: Observable<DealConfigurationQuery['Deal']>
    @Input() layoutTrigger$: ReplaySubject<boolean>
    @Input() modelName: string
    @Input() routeIndex: number
    @Input() withCarPreview: boolean

    @ViewChild('remainingFieldsElement') remainingOptionsElement: ElementRef<Element>

    getSidebarPositioningState() {
        this.isSidebarSticky = window.scrollY >= this.remainingOptionsElementOffset - window.innerHeight
    }

    @HostListener('window:scroll')
    onScroll() {
        this.getSidebarPositioningState()
    }

    @HostListener('window:resize')
    onResize() {
        this.remainingOptionsElementOffset = this.remainingOptionsElement.nativeElement.getBoundingClientRect().top
        this.getSidebarPositioningState()
    }

    @HostListener('window:click', ['$event.target'])
    onClick(target) {
        if (this.isMobileInfoPanelOpen && !target.closest('.checkout-sidebar__body')) {
            this.toggleMobileInfoPanelVisibility(false)
        } else if (!this.isMobileInfoPanelOpen && target.closest('.checkout-sidebar__header')) {
            this.toggleMobileInfoPanelVisibility(true)
        }
    }

    ngAfterViewInit() {
        this.isPrecededByActionBanner = !!this.actionBannerService.retrieveBannerDetails().mainContent

        this.layoutTrigger$.pipe(untilDestroyed(this)).subscribe(shouldTriggerLayoutReflow => {
            if (shouldTriggerLayoutReflow) {
                setTimeout(() => {
                    if (!this.remainingOptionsElementOffset) {
                        this.remainingOptionsElementOffset =
                            this.remainingOptionsElement.nativeElement.getBoundingClientRect().top
                    }

                    this.getSidebarPositioningState()
                }, 0)
            }
        })
    }

    toggleMobileInfoPanelVisibility(openPanel: boolean) {
        this.isMobileInfoPanelOpen = openPanel
    }
}
